import { env } from '@/env';
import qs from 'query-string';

export type MonitorPaginationKey = {
  application_id: { S: string };
  key: { S: string };
};

export type MonitorEventKind =
  | 'pigello_event'
  | 'webhook_event'
  | 'pigello_cron_event';

type MonitorSession = {
  token: string;
  userId: string;
  customerId: string;
};

// Shared URL + auth-header shape for the integration monitor, used by
// useIntegrationQuery, useInfinitIntegrationQuery and
// useIntegrationMonitorEvents. Each caller keeps its own fetch/error
// semantics.
export function buildMonitorRequest({
  eventKind,
  applicationId,
  serviceId,
  serviceVersionId,
  targetContentType,
  targetObjectId,
  pageLimit = 50,
  paginationKey = '',
  queryString,
  session,
}: {
  eventKind: MonitorEventKind;
  applicationId: string;
  serviceId: string;
  serviceVersionId: string;
  targetContentType: string;
  targetObjectId: string;
  pageLimit?: number;
  paginationKey?: string;
  queryString?: string;
  session: MonitorSession;
}): { url: string; headers: HeadersInit } {
  return {
    url: qs.stringifyUrl({
      url: `${env.NEXT_PUBLIC_INTEGRATION_MONITOR_URL}/query/${eventKind}/`,
      query: {
        page_limit: pageLimit,
        pagination_key: paginationKey,
        application_id: applicationId,
        service_id: serviceId,
        service_version_id: serviceVersionId,
        target_content_type: targetContentType,
        target_object_id: targetObjectId,
        ...(queryString ? { ...qs.parse(queryString) } : {}),
      },
    }),
    headers: {
      Authorization: `Token ${session.token}`,
      'X-PIGELLO-USER-ID': session.userId,
      'X-PIGELLO-CUSTOMER-ID': session.customerId,
    },
  };
}
